import React from 'react'
import {usePopperTooltip} from 'react-popper-tooltip'
import {connect} from 'react-redux'
import actions from 'redux-auto'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Api from '#services/api'
import {useUserInfo} from '#hooks/store/useUserInfo'
import Avatar from '#components/a/Avatar'
import Profile from '#components/a/Profile'
import Upload from '#components/a/form/Upload'
import {useAuth} from 'oidc-react'

export function Usercenter({userId, trackingDisabled}) {
  const userInfo = useUserInfo(userId)
  const {getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible} = usePopperTooltip({
    trigger: 'click',
    placement: 'bottom',
  })

  const auth = useAuth()
  async function logout(e) {
    e.preventDefault()
    actions.authentication.resetUserData()
    await auth.signOutRedirect({})
  }

  function changeTrackingDisabled() {
    actions.settings.setTrackingDisabled({trackingDisabled: !trackingDisabled})
  }
  async function updateProfileImage(id) {
    await Api.updateProfileImage(id)
  }

  const handleUpdatePhoto = async e => {
    try {
      const file = e?.target?.files && e.target.files[0]
      const uploadedFile = await Api.uploadFile(file)
      await updateProfileImage(uploadedFile.blobId)
    } catch (error) {
      actions.error.writeError({error})
    } finally {
      actions.userInfo.getUserInfo({userId})
    }
  }

  async function handleDeletePhoto() {
    try {
      await Api.deleteProfileImage()
    } catch (error) {
      actions.error.writeError({error})
    } finally {
      actions.userInfo.getUserInfo({userId})
    }
  }

  const renderPlaceholder = () => (
    <div className="usercenter">
      <div className="profile">
        <div className="userName username__placeholder" />
        <div className="profile__role profile__role__placeholder" />
      </div>
      <div className="usercenter__avatar__placeholder">
        <Avatar />
      </div>
    </div>
  )

  const trackingText = trackingDisabled ? 'enable_at_tracking' : 'disable_at_tracking'
  if (!userInfo) {
    return renderPlaceholder()
  }

  return (
    <div className="usercenter">
      <Profile userInfo={userInfo} />

      <div ref={setTriggerRef} className="usercenter__avatar" data-testid="tooltip-profile">
        <Avatar profileImage={userInfo.profileImage} />
      </div>

      {visible && (
        <div ref={setTooltipRef} {...getTooltipProps({className: 'tooltip-container'})}>
          <div
            {...getArrowProps({
              className: 'tooltip-arrow',
            })}
          />
          <Upload
            labelText={i18n.t('menu_upload_profile_photo')}
            modifier="profileImage"
            onChangeHandle={handleUpdatePhoto}
            accept="image/jpeg, image/png"
            isUploading={false}
          />
          <div className="tooltip-container__entry-hr" />
          {userInfo.profileImage !== undefined && (
            <>
              <button type="button" onClick={handleDeletePhoto} className="tooltip-container__entry">
                {i18n.t('menu_delete_profile_photo')}
              </button>
              <div className="tooltip-container__entry-hr" />
            </>
          )}
          <a
            href="https://forms.office.com/r/nZHqZXEW4c"
            target="_blank"
            rel="noopener noreferrer"
            className="tooltip-container__entry">
            {i18n.t('feedback')}
          </a>
          <div className="tooltip-container__entry-hr" />
          <a
            href="https://azubiguide.edeka/anleitungen"
            target="_blank"
            rel="noopener noreferrer"
            className="tooltip-container__entry">
            {i18n.t('faq')}
          </a>
          <div className="tooltip-container__entry-hr" />
          <a
            href="https://verbund.edeka/karriere/karrierem%C3%B6glichkeiten/f%C3%BCr-mitarbeiter/digitale-lernmedien/impressum-digitaler-lernmedien/"
            target="_blank"
            rel="noopener noreferrer"
            className="tooltip-container__entry">
            {i18n.t('imprint')}
          </a>
          <div className="tooltip-container__entry-hr" />
          <a
            href="https://verbund.edeka/karriere/karrierem%C3%B6glichkeiten/f%C3%BCr-mitarbeiter/digitale-lernmedien/datenschutz-digitaler-lernmedien/"
            target="_blank"
            rel="noopener noreferrer"
            className="tooltip-container__entry">
            {i18n.t('privacy')}
          </a>
          <div className="tooltip-container__entry-hr" />
          <a
            href="https://verbund.edeka/karriere/karrieremöglichkeiten/für-mitarbeiter/digitales-lernen/azubiguide/systeminformationen/"
            target="_blank"
            rel="noopener noreferrer"
            className="tooltip-container__entry">
            {i18n.t('infobutton_text')}
          </a>

          <div className="tooltip-container__entry-hr" />
          <button type="button" onClick={changeTrackingDisabled} className="tooltip-container__entry">
            {i18n.t(trackingText)}
          </button>
          <div className="tooltip-container__entry-hr" />
          <button type="button" onClick={logout} className="tooltip-container__entry">
            {i18n.t('logout')}
          </button>
        </div>
      )}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    userId: state.authentication.id,
    trackingDisabled: state.settings.trackingDisabled,
  }
}

Usercenter.propTypes = {
  userId: PropTypes.number,
  trackingDisabled: PropTypes.bool,
}

export default connect(mapStateToProps)(Usercenter)
